module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEXSURBVHgB1ZXhDYIwEIUP4wCOwAa6gbCBG4gTyAa4ibiBG4gToBPACG5QX6VERI5eAX/4JZcaqN87CmmJ/gWl1AK1oV9g5LmqSGhKWnLFhuDiHlUonoNQ/hHimYlHDBEqQ12ZZjPP87KmHMMFtSKenZ4YcR1yWDqvyV9NmB9nB7kvlps/iLs38kIsBzMSouVUrbnfM+2GCvGuHk4BQ+WiAKG87JJbA8bKrQEgEcpLboItICAHOZ44aH+RbIBZHl8qbzSUiAKI774ky7JIA9Yd4tRFrpn33PONUG9+mYtUFABhSBMg3irGBJT0vd5DWVK1ZbzB5xibXTCmEajqRNREzev1iZZi2KL0uXAnd/QKBKgT3l3UvPEEOAtfMnOG7wMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/edit@2x.png
// module id = 1722
// module chunks = 0